import { VersusGameScreen } from '@/screens/mini-games'

export default function () {
  return <VersusGameScreen />
}
